// extracted by mini-css-extract-plugin
export default {"container":"UserCard_container__iRB0O","card_brand":"UserCard_card_brand__UCXXA","mask":"UserCard_mask__5GLw3","created":"UserCard_created__c+p1R"};